module.exports = __webpack_public_path__ + "static/media/prosieben.a3806c54.png";